import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { SectionBannerComponent } from '../../shared/section-banner/section-banner.component';
import { TechnologiesComponent } from '../../shared/technologies/technologies.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-arqit-services',
  standalone: true,
  imports: [SectionBannerComponent, TechnologiesComponent, CommonModule, TranslateModule],
  templateUrl: './arqit-services.component.html',
  styleUrls: ['./arqit-services.component.scss'],
})
export class ArqitServicesComponent implements OnInit, AfterViewInit {
  @ViewChild('descriptionSection') descriptionSection!: ElementRef;

  selectedService = 0;

  services = [
    {
      id: 1,
      name: 'services.arquitectura_ti.name',
      description: 'services.arquitectura_ti.description',
      client: 'services.arquitectura_ti.client',
      tools: 'services.arquitectura_ti.tools',
      image: 'assets/img/img-services/arquitectura-ti.png',
      imageWebP: 'assets/webp/arquitectura-ti.webp',
      link: '/arqit-services/arquitectura-ti',
      alt: 'services.arquitectura_ti.name',
    },
    {
      id: 2,
      name: 'services.cloud_native.name',
      description: 'services.cloud_native.description',
      client: 'services.cloud_native.client',
      tools: 'services.cloud_native.tools',
      image: 'assets/img/img-services/cloud-native.png',
      imageWebP: 'assets/webp/cloud-native.webp',
      link: '/arqit-services/cloud-native',
      alt: 'services.cloud_native.name',
    },
    {
      id: 3,
      name: 'services.celulas_agiles.name',
      description: 'services.celulas_agiles.description',
      client: 'services.celulas_agiles.client',
      tools: 'services.celulas_agiles.tools',
      image: 'assets/img/img-services/celulas-agiles.png',
      imageWebP: 'assets/webp/celulas-agiles.webp',
      link: '/arqit-services/celulas-agiles',
      alt: 'services.celulas_agiles.name',
    },
    {
      id: 4,
      name: 'services.soporte_mantencion.name',
      description: 'services.soporte_mantencion.description',
      client: 'services.soporte_mantencion.client',
      tools: 'services.soporte_mantencion.tools',
      image: 'assets/img/img-services/soporte-mantencion.png',
      imageWebP: 'assets/webp/soporte-mantencion.webp',
      link: '/arqit-services/soporte-mantenimiento',
      alt: 'services.soporte_mantencion.name',
    },
    {
      id: 5,
      name: 'services.devops_automatizacion.name',
      description: 'services.devops_automatizacion.description',
      client: 'services.devops_automatizacion.client',
      tools: 'services.devops_automatizacion.tools',
      image: 'assets/img/img-services/devops-auto.png',
      imageWebP: 'assets/webp/devops-auto.webp',
      link: '/arqit-services/devops-automatizacion',
      alt: 'services.devops_automatizacion.name',
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const serviceId = +params['id'];
      if (serviceId && serviceId > 0 && serviceId <= this.services.length) {
        this.selectedService = serviceId;
      }
    });

    this.translate.onLangChange.subscribe(() => {
      
    });
  }

  ngAfterViewInit(): void {
    this.scrollToDescriptionSection();
  }

  selectService(serviceIndex: number, event: MouseEvent): void {
    event.preventDefault();
    this.selectedService = serviceIndex;
    this.scrollToDescriptionSection();
  }

  scrollToDescriptionSection(): void {
    if (this.descriptionSection) {
      const offset = 272;
      const top = this.descriptionSection.nativeElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  }

  goToService(serviceId: number): void {
    this.router.navigate(['/arqit-services', serviceId]);
  }
}
